import { render, staticRenderFns } from "./formother.vue?vue&type=template&id=3ef7685f&"
import script from "./formother.vue?vue&type=script&lang=js&"
export * from "./formother.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports